/**
 * External dependencies
 */
import { ColumnsIcon } from '~cartzillagb/icons'
import { disabledBlocks, i18n } from 'cartzillagb'

/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'


const schema = {
    className: {
        type: 'string',
    },
    limit: {
        type: 'limit',
        default: 2,
    },
    rowClass: {
        type: 'string',
    },
    enableContainer: {
        type: 'boolean',
        default: true,
    },
    enableGutter: {
        type: 'boolean',
        default: true,
    },
}

export const name = 'czgb/columns'

export const settings = {
    title: __( 'Columns', i18n ),
    description: __( 'The columns block lets you create multi-column layouts within your content area, and include other blocks inside each column.', i18n ),
    icon: ColumnsIcon,
    example: {
        innerBlocks: [ { name: 'czgb/column' } ],
    },
    category: 'cartzillagb',
    keywords: [
        __( 'Columns', i18n ),
        __( 'cartzillaGB', i18n ),
    ],
    attributes: schema,

    supports: {
        inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
    },

    edit,
    save,

    // CartzillaGB modules.
    modules: {
        'advanced-responsive': true,
    },
}